export default "__VITE_ASSET__DobvhBWE__"